import React, { useState } from "react";
import Styles from "./Heading.module.css";
import { Add } from "@mui/icons-material";
import BankingListingModal from "../../Modals/BankingListingModal/BankingListingModal";
import { useSelector } from "react-redux";

const SelfHeader = ({ filteredListings, activeFilter }) => {
  const [addListing, setAddListing] = useState(false);

  const bankingState = useSelector((state) => state?.bankingSlice || {});
  const allListings = bankingState?.allListings || [];
  const count = filteredListings?.length || 0;

  const handleOpen = () => {
    setAddListing(true);
  };

  const handleClose = () => {
    setAddListing(false);
  };

  return (
    <>
      {addListing && (
        <BankingListingModal
          open={addListing}
          handleClose={handleClose}
          mode="create"
          heading="Add Banking Listing"
        />
      )}

      <div className={`display_flex_row ${Styles.selfHeaderContainer}`}>
        <div
          className={`display_flex_row_center ${Styles.selfHeaderLeft} ${Styles.selfHeader}`}
        >
          <span>My Listing: </span>
          <span>{count}</span>
        </div>
        <div
          className={`display_flex_row_center ${Styles.addListingButton}`}
          onClick={handleOpen}
        >
          <Add style={{ fontSize: "16px" }} />
          <span>Add Listing</span>
        </div>
        
      </div>
    </>
  );
};

export default SelfHeader;
